<template>
  <v-card class="card">
    <v-card-title class="accent--text pb-4"><span class="card-title">Персональные данные</span></v-card-title>
    <v-card-text outlined tile class="border-top">
      <v-row class="px-3 pt-3">
        <template v-if="personalData?.id">

          <v-col cols="12" class="px-0">
            <div class="accent--text font-weight-bold">Пол</div>
            <div class="accent--text">{{personalData.gender?.name}}</div>
          </v-col>

          <v-col
            cols="12"
            class="pa-0 border-top"
            v-for="(item, i) in personalData.personalNameList"
            :key="i"
          >
            <v-col cols="12" class="pt-3 px-0">
              <div class="accent--text font-weight-bold">ФИО</div>
              <div class="accent--text">{{item.fullName}}</div>
            </v-col>

            <v-col cols="12" class="pt-0 px-0">
              <div class="accent--text font-weight-bold">ФИО в родительном падеже</div>
              <div class="accent--text">{{item.fullNameGenitive}}</div>
            </v-col>
          </v-col>

          <v-col
            cols="12"
            class="pa-0 border-top"
            v-for="(item, i) in personalData.personalContactList"
            :key="i + 50"
          ><!--Лень было что-то придумывать "i+50" для того, что бы не было дубликатов ключей-->
            <v-col cols="12" class="pt-3 px-0">
              <div class="accent--text font-weight-bold">Мобильный телефон</div>
              <div class="accent--text">{{item.cellularPhone}}</div>
            </v-col>

            <v-col cols="12" class="pt-0 px-0">
              <div class="accent--text font-weight-bold">Домашний телефон</div>
              <div class="accent--text">{{item.homePhone || '-'}}</div>
            </v-col>

            <v-col cols="12" class="pt-0 px-0">
              <div class="accent--text font-weight-bold">E-mail</div>
              <div class="accent--text">{{item.email}}</div>
            </v-col>
          </v-col>

          <v-col
            cols="12"
            class="pa-0 border-top"
            v-for="(item, i) in personalData.addressGarList"
            :key="i + 100"
          ><!--И тут тоже было лень "i+100" для того, что бы не было дубликатов ключей-->
            <v-col cols="12" class="pt-3 px-0">
              <div class="accent--text font-weight-bold">Вид регистрации</div>
              <div class="accent--text">{{item.addressType?.name}}</div>
            </v-col>

            <v-col cols="12" class="pt-0 px-0">
              <div class="accent--text font-weight-bold">Страна</div>
              <div class="accent--text">{{item.country?.name}}</div>
            </v-col>

            <v-col cols="12" class="pt-0 px-0">
              <div class="accent--text font-weight-bold">Адрес</div>
              <div class="accent--text">{{item.fullAddress}}</div>
            </v-col>

            <v-col cols="12" class="pt-0 px-0">
              <div class="accent--text font-weight-bold">Квартира</div>
              <div class="accent--text">{{item.flat}}</div>
            </v-col>

            <v-col cols="12" class="pt-0 px-0">
              <div class="accent--text font-weight-bold">Индекс</div>
              <div class="accent--text">{{item.postalCode}}</div>
            </v-col>
          </v-col>
        </template>

        <template v-else>
          <v-col cols="12" class="pt-0 px-0">
            <div class="accent--text">Нет данных</div>
          </v-col>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: "PersonalDataCard",

  props: {
    personalData: Object
  },
}
</script>

<style scoped>
.card {
  border-radius: 20px !important;
}

.card-title {
  word-break: normal !important;
}

.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
